import type { DataTableHeader } from '@/types/vuetify';
import i18n from '@/plugins/i18n';

export function createPageVisitHistoryPageHeaders(): DataTableHeader[] {
    const t = i18n.global.t;

    return [
        {
            title: '',
            key: 'data-table-expand',
            value: 'data-table-expand',
            align: 'center',
            sortable: false,
            minWidth: 28,
            width: 28,
            cellProps: { class: 'px-0' },
        },
        {
            title: t('pageVisitHistory.date'),
            value: 'created_at',
            key: 'created_at',
            align: 'start',
            sortable: true,
            nowrap: true,
        },
        {
            title: t('pageVisitHistory.page'),
            value: 'pageId',
            key: 'pageId',
            align: 'start',
            sortable: false,
            nowrap: true,
        },
        {
            title: t('pageVisitHistory.user'),
            value: 'userName',
            key: 'userName',
            align: 'start',
            sortable: false,
            nowrap: true,
        },
        {
            title: t('pageVisitHistory.appId'),
            value: 'uniqAppId',
            key: 'uniqAppId',
            align: 'start',
            sortable: false,
            nowrap: true,
        },
        {
            title: t('pageVisitHistory.number'),
            value: 'count',
            key: 'count',
            align: 'end',
            sortable: false,
            nowrap: true,
        },
        {
            title: t('pageVisitHistory.url'),
            value: 'url',
            key: 'url',
            align: 'start',
            sortable: false,
            nowrap: true,
        },
        {
            title: t('pageVisitHistory.agent'),
            value: 'userAgent',
            key: 'userAgent',
            align: 'start',
            sortable: false,
            nowrap: true,
            headerProps: { class: 'nowrap pvh-col-agent' },
            cellProps: { class: 'pvh-col-agent' },
        },
        {
            title: '',
            value: 'infoMenu',
            key: 'infoMenu',
            align: 'end',
            sortable: false,
            nowrap: true,
            width: 48,
            headerProps: { class: 'px-0' },
            cellProps: { class: 'pl-0 pr-1' },
        },
    ];
}
